// extracted by mini-css-extract-plugin
module.exports = {"expansion-panel":"acf-expansion-panel_expansion-panel__qvfK9","expansion-panel__content":"acf-expansion-panel_expansion-panel__content__U8Gvi"};